import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { Reveal } from "@/components/Reveal";
import { nav } from "@/config/site";

export default function NotFound() {
  return (
    <>
      <Seo title="Page introuvable (404) | MINES DE PARIS" description="La page demandée n'existe pas ou a été déplacée." path="/404" noindex />
      <section className="relative flex min-h-[100svh] items-center overflow-hidden bg-night pt-24 text-white grain" data-testid="not-found-page">
        <div className="absolute inset-0 grid-lines" aria-hidden="true" />
        <div className="container-x relative py-20">
          <Reveal className="max-w-2xl">
            <p className="font-heading text-[clamp(5rem,18vw,12rem)] font-extrabold leading-none text-white/10" aria-hidden="true">404</p>
            <h1 className="h-display -mt-6">Page introuvable</h1>
            <p className="lede mt-6 !text-white/75">La page que vous recherchez n'existe pas ou a été déplacée. Vous pouvez poursuivre votre navigation via les liens ci-dessous.</p>
            <div className="mt-10 flex flex-wrap gap-3">
              {nav.map((n) => (
                <Link key={n.to} to={n.to} className="btn-outline-light" data-testid={`notfound-link-${n.to === "/" ? "accueil" : n.to.slice(1)}`}>{n.label}</Link>
              ))}
              <Link to="/contact#devis" className="btn-gold" data-testid="notfound-devis-btn">Demander un devis <ArrowRight className="h-4 w-4" /></Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
